import { DIFFS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
const reproApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getFailedReproChecks: build.query({
            query: (data) => ({
                url: `${DIFFS_ENDPOINT}/${data.ui_id}/repro`,
                params: data,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetFailedReproChecksQuery } = reproApi;
//# sourceMappingURL=repro.api.js.map